"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eInsuranceQuoteRejectionReason = void 0;
const utils_1 = require("@loadsure/utils");
const _1 = require(".");
const date_fns_1 = require("date-fns");
const certificate_1 = require("../certificate");
const insuranceQuote_1 = require("../insuranceQuote");
const insuranceCoverage_1 = require("../insuranceCoverage");
const address_1 = __importDefault(require("../address"));
const assured_1 = __importDefault(require("../assured"));
const insuranceCoverage_2 = require("../insuranceCoverage/insuranceCoverage");
const partner_1 = __importStar(require("../partner"));
const shipmentContact_1 = __importDefault(require("../shipmentContact"));
const shipment_1 = __importDefault(require("../shipment"));
const user_1 = __importDefault(require("../user"));
var eInsuranceQuoteRejectionReason;
(function (eInsuranceQuoteRejectionReason) {
    eInsuranceQuoteRejectionReason["REJCOP"] = "Shipment lost to competition";
    eInsuranceQuoteRejectionReason["REJVAL"] = "Insured value changed";
    eInsuranceQuoteRejectionReason["REJREQ"] = "Insurance was not required by the shipper";
    eInsuranceQuoteRejectionReason["REJCHP"] = "Cheaper insurance found elsewhere";
    eInsuranceQuoteRejectionReason["REJREP"] = "Origin/destination/commodity changed";
    eInsuranceQuoteRejectionReason["REJASD"] = "Assured changed";
    eInsuranceQuoteRejectionReason["REJNLN"] = "Insurance no longer needed";
    eInsuranceQuoteRejectionReason["REJQCE"] = "Quote created in error";
    eInsuranceQuoteRejectionReason["REJOTH"] = "Other";
})(eInsuranceQuoteRejectionReason = exports.eInsuranceQuoteRejectionReason || (exports.eInsuranceQuoteRejectionReason = {}));
class InsuranceQuote {
    constructor(partner, user, coverage, assured, shipment, partnerIds, authorizedUsers, channel, sandbox, quoteId, quoteStatusInternal, createdDate, expiredDate, quoteRecipient, shipmentContact, sendEmailsTo, additionalComments, token, underwriting, underwritingCoverageUpdates, accountId) {
        this.partner = partner;
        this.user = user;
        this.coverage = coverage;
        this.assured = assured;
        this.shipment = shipment;
        this.partnerIds = partnerIds;
        this.authorizedUsers = authorizedUsers;
        this.channel = channel;
        this.sandbox = sandbox;
        this.quoteId = quoteId;
        this.createdDate = createdDate;
        this.expiredDate = expiredDate;
        this.quoteRecipient = quoteRecipient;
        this.shipmentContact = shipmentContact;
        this.sendEmailsTo = sendEmailsTo;
        this.additionalComments = additionalComments;
        this.token = token;
        this.underwriting = underwriting;
        this.underwritingCoverageUpdates = underwritingCoverageUpdates;
        this.accountId = accountId;
        if (quoteStatusInternal === insuranceQuote_1.eQuoteStatus.PENDING &&
            date_fns_1.isPast(date_fns_1.parseISO(this.expiredDate))) {
            this.quoteStatus = insuranceQuote_1.eQuoteStatus.EXPIRED;
        }
        else {
            this.quoteStatus = quoteStatusInternal;
        }
    }
    setToken(token) {
        this.token = token;
    }
    static fromObj(data) {
        var _a, _b, _c;
        const assured = data.assured ? data.assured : data.shipment.assured;
        const shipmentContact = data.shipmentContact
            ? shipmentContact_1.default.fromObj(data.shipmentContact)
            : undefined;
        const authorizedUsers = Array.from(new Set([(_a = data === null || data === void 0 ? void 0 : data.user) === null || _a === void 0 ? void 0 : _a.email.toLowerCase(), assured === null || assured === void 0 ? void 0 : assured.email.toLowerCase(), ...data.authorizedUsers]));
        const createdDate = (_b = data.createdDate) !== null && _b !== void 0 ? _b : date_fns_1.formatISO(data.createdDate.toDate());
        const shipment = shipment_1.default.fromObj(data.shipment);
        const expiredDate = data.expiredDate ||
            _1.calculateQuoteExpiryDate(createdDate, shipment.pickupStop);
        const partnerIds = (_c = data.partnerIds) !== null && _c !== void 0 ? _c : [data.partner.id];
        const coverage = insuranceCoverage_2.getInsuranceCoverage(data);
        return new InsuranceQuote(partner_1.default.fromObj(data.partner), user_1.default.fromObj(data.user), coverage, assured_1.default.fromObj(assured), shipment, partnerIds, authorizedUsers, data.channel, data.sandbox, data.quoteId, data.quoteStatus || insuranceQuote_1.eQuoteStatus.PENDING, createdDate, expiredDate, user_1.default.fromObj(data.quoteRecipient), shipmentContact, data.sendEmailsTo, data.additionalComments, data.token, data.underwriting, data.underwritingCoverageUpdates, data.accountId);
    }
    static create(partner, partnerIds, insuranceQuote, sandbox, timeZoneName, accountId) {
        const createdDate = date_fns_1.formatISO(new Date());
        const expiredDate = _1.calculateQuoteExpiryDate(createdDate, insuranceQuote.shipment.pickupStop).toISOString();
        const authorizedUsers = Array.from(new Set([
            insuranceQuote.user.email.toLowerCase(),
            insuranceQuote.assured.email.toLowerCase(),
            insuranceQuote.quoteRecipient.email.toLowerCase()
        ]));
        return new InsuranceQuote(partner, insuranceQuote.user, insuranceQuote.coverage, insuranceQuote.assured, insuranceQuote.shipment, partnerIds, authorizedUsers, insuranceQuote.channel, sandbox !== null && sandbox !== void 0 ? sandbox : partner_1.isSandboxPartner(partner.id), insuranceQuote.quoteId, insuranceQuote.quoteStatus, createdDate, expiredDate, insuranceQuote.quoteRecipient, insuranceQuote.shipmentContact, insuranceQuote.sendEmailsTo, insuranceQuote.additionalComments, undefined, undefined, undefined, accountId);
    }
    get secondsTillExpiry() {
        const expiryDate = date_fns_1.parseISO(this.expiredDate);
        return date_fns_1.differenceInSeconds(expiryDate, new Date());
    }
    getDetails() {
        var _a, _b;
        const createdDateISO = this.createdDate
            ? date_fns_1.format(date_fns_1.parseISO(this.createdDate), "yyyy-MM-dd 'at' ppp")
            : "unknown";
        const expiredDateISO = this.expiredDate
            ? date_fns_1.format(date_fns_1.parseISO(this.expiredDate), "yyyy-MM-dd 'at' ppp")
            : "unknown";
        const { quoteId, quoteStatus, quoteRecipient, sendEmailsTo, additionalComments, token, underwriting } = this;
        const underwritingCoverageUpdates = {
            premium: utils_1.formatCurrency((_a = underwriting === null || underwriting === void 0 ? void 0 : underwriting.coverage) === null || _a === void 0 ? void 0 : _a.orgPremium, this.coverage.currency),
            deductible: utils_1.formatCurrency((_b = underwriting === null || underwriting === void 0 ? void 0 : underwriting.coverage) === null || _b === void 0 ? void 0 : _b.orgDeductible, this.coverage.currency)
        };
        const sendToUserHolder = !!(sendEmailsTo === null || sendEmailsTo === void 0 ? void 0 : sendEmailsTo.includes(insuranceCoverage_1.eSendEmailTo.USER));
        const sendToRecipientUser = !!(sendEmailsTo === null || sendEmailsTo === void 0 ? void 0 : sendEmailsTo.includes(insuranceCoverage_1.eSendEmailTo.QUOTE_RECIPIENT));
        const sendToCreatorUser = !!(sendEmailsTo === null || sendEmailsTo === void 0 ? void 0 : sendEmailsTo.includes(insuranceCoverage_1.eSendEmailTo.QUOTE_CREATOR));
        return Object.assign(Object.assign({}, certificate_1.getShipmentCoverageDetails(this)), { quoteId,
            quoteStatus, createdDate: createdDateISO, expiredDate: expiredDateISO, sendToUserHolder,
            sendToRecipientUser,
            sendToCreatorUser, quoteRecipientEmail: quoteRecipient.email, additionalComments,
            token,
            underwritingCoverageUpdates });
    }
    getSummary() {
        return {
            quoteId: this.quoteId,
            productId: this.coverage.id,
            productName: this.coverage.name,
            limit: this.coverage.limit,
            deductible: this.coverage.deductible
        };
    }
    static getBuyQuoteApiPathFromId(quoteId) {
        return `/certificates/buyQuote?id=${quoteId}`;
    }
    static getQuotePdfApiPathFromId(quoteId) {
        return `quoteLoad/${quoteId}/pdf`;
    }
    get quoteValidationApiPath() {
        return InsuranceQuote.getBuyQuoteApiPathFromId(this.quoteId);
    }
    static getStatusLabel(status) {
        let label = `${status}`;
        if (status === insuranceQuote_1.eQuoteStatus.UW_REJECTED ||
            status === insuranceQuote_1.eQuoteStatus.UW_REVIEW) {
            const labelArray = label.split("_");
            label = `${labelArray[0].toUpperCase()} ${labelArray[1]} `;
        }
        return label.replace(/(?:^|\s)\S/g, (res) => res.toUpperCase());
    }
    get isPending() {
        return this.quoteStatus === insuranceQuote_1.eQuoteStatus.PENDING;
    }
    get isCancelable() {
        return this.isPending || this.quoteStatus === insuranceQuote_1.eQuoteStatus.UW_REVIEW;
    }
    getAddressByStopType(type) {
        const stop = this.shipment.stops.find((aStop) => aStop.stopType === type);
        const address = stop === null || stop === void 0 ? void 0 : stop.address;
        const addressClass = new address_1.default(address === null || address === void 0 ? void 0 : address.address1, address === null || address === void 0 ? void 0 : address.city, address === null || address === void 0 ? void 0 : address.state, address === null || address === void 0 ? void 0 : address.postal, address === null || address === void 0 ? void 0 : address.country);
        return addressClass === null || addressClass === void 0 ? void 0 : addressClass.shortAddress;
    }
}
exports.default = InsuranceQuote;
//# sourceMappingURL=insuranceQuote.class.js.map